import { render } from "./CreatePurchasOrderModal.vue?vue&type=template&id=38a2e9bb&scoped=true"
import script from "./CreatePurchasOrderModal.vue?vue&type=script&lang=js"
export * from "./CreatePurchasOrderModal.vue?vue&type=script&lang=js"

import "./CreatePurchasOrderModal.vue?vue&type=style&index=0&id=38a2e9bb&scoped=true&lang=css"

import exportComponent from "../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a2e9bb"]])

export default __exports__